import React from 'react';

export const AirPressureIconGray = ({
  width = 24,
  height = 24,
}: {
  width?: number;
  height?: number;
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 45 34"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.1244 25.5782C8.94721 18.4466 14.5356 12.3841 21.6583 11.9868C29.1146 11.5709 35.422 17.3603 35.6813 24.7868C35.7405 26.4799 35.4787 28.1091 34.9523 29.6176C34.5998 30.6276 35.0891 31.7392 36.0602 32.1876L39.3181 33.6928C40.4289 34.2059 41.743 33.6636 42.1657 32.5155C43.0476 30.1197 43.5049 27.5239 43.4493 24.8227C43.2094 13.1871 33.4517 3.88377 21.8183 4.20998C10.1297 4.53771 0.961674 14.3179 1.36902 25.9852C1.45083 28.3279 1.91316 30.5674 2.69399 32.6474C3.13101 33.8118 4.48784 34.3343 5.59857 33.7744L8.79852 32.1615C9.73509 31.6894 10.1979 30.5974 9.8536 29.6067C9.41424 28.3424 9.15944 26.9896 9.1244 25.5782Z"
      fill="#EBEBEB"
    />
    <path
      d="M2.69448 32.6477C1.91365 30.5678 1.45132 28.3282 1.36951 25.9855C1.07301 17.4932 5.84959 10.0006 12.9787 6.42529L16.3685 13.4262C11.9657 15.6936 8.99495 20.3485 9.12489 25.5785C9.15992 26.99 9.41473 28.3428 9.85409 29.607C10.1984 30.5978 9.73558 31.6897 8.79901 32.1618L5.59906 33.7747C4.48832 34.3346 3.1315 33.8121 2.69448 32.6477Z"
      fill="#BFBFBF"
    />
    <path
      d="M34.9528 29.6176C35.4791 28.1091 35.741 26.4798 35.6818 24.7867C35.5077 19.8014 32.6082 15.5539 28.4653 13.4259C28.8371 12.6428 30.9926 8.29543 31.9611 6.51221C38.63 9.93898 43.285 16.8307 43.4498 24.8226C43.5054 27.5239 43.0481 30.1197 42.1662 32.5155C41.7434 33.6636 40.4293 34.2059 39.3186 33.6928L36.0607 32.1876C35.0896 31.7392 34.6002 30.6276 34.9528 29.6176Z"
      fill="#BFBFBF"
    />
    <path
      d="M26.8722 25.6691C26.3179 21.7315 25.4695 15.7847 24.7139 10.8212C24.3363 8.34038 23.9811 6.10013 23.6969 4.47797C23.5552 3.66863 23.4295 3.00357 23.3263 2.53674C23.2755 2.30649 23.2262 2.10655 23.1793 1.95669C23.1574 1.88645 23.1267 1.79652 23.0851 1.71261C23.066 1.6741 23.0262 1.59855 22.9598 1.52167C22.9173 1.4724 22.7198 1.25 22.3735 1.25C22.0271 1.25 21.8296 1.4724 21.7871 1.52167C21.7208 1.59855 21.681 1.6741 21.6619 1.71261C21.6203 1.79652 21.5895 1.88645 21.5676 1.95669C21.5207 2.10655 21.4715 2.30649 21.4206 2.53674C21.3174 3.00357 21.1917 3.66863 21.05 4.47797C20.7659 6.10013 20.4107 8.34038 20.033 10.8212C19.2774 15.7847 18.4291 21.7315 17.8748 25.6691C17.4898 28.404 19.6155 30.837 22.3735 30.837C25.1314 30.837 27.2572 28.404 26.8722 25.6691Z"
      fill="#9B9B9B"
      stroke="white"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);
